import { Grid, Typography } from "@mui/material";

interface CustomNoteProps {
  note: string
}
export default function CustomNote({ note }: CustomNoteProps) {

  return (
    <Grid item xs={12}>
      <Typography
        variant="subtitle2"
        style={{
          color: '#000000',
        }}
      >
        {note}
      </Typography>
    </Grid>
  )

}